import { useState } from 'react';

interface UseFilePreviewReturn {
    isOpen: boolean;
    filePath: string;
    fileData: File | Blob | null;
    filename: string;
    openPreview: (path: string, filename?: string) => void;
    openPreviewWithData: (file: File | Blob, filename?: string) => void;
    closePreview: () => void;
}

export const useFilePreview = (): UseFilePreviewReturn => {
    const [isOpen, setIsOpen] = useState(false);
    const [filePath, setFilePath] = useState('');
    const [fileData, setFileData] = useState<File | Blob | null>(null);
    const [filename, setFilename] = useState('');

    const openPreview = (path: string, filename?: string) => {
        // Use the dialog for all devices since @react-pdf-viewer handles mobile properly
        setFilePath(path);
        setFileData(null);
        // Pass filename with extension (e.g. .png) so dialog can show image/PDF preview
        setFilename(filename ?? path.split('/').pop() ?? '');
        setIsOpen(true);
    };

    const openPreviewWithData = (file: File | Blob, name?: string) => {
        // Preview with file data (no need to fetch)
        setFilePath('');
        setFileData(file);
        setFilename(name || (file instanceof File ? file.name : 'file'));
        setIsOpen(true);
    };

    const closePreview = () => {
        setIsOpen(false);
        setFilePath('');
        setFileData(null);
        setFilename('');
    };

    return {
        isOpen,
        filePath,
        fileData,
        filename,
        openPreview,
        openPreviewWithData,
        closePreview,
    };
}; 